module.exports = __webpack_public_path__ + "img/item-4.c441575.png";